//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadImg from '@/assets/img/upload_cross.png'
import { isImage } from '@/utils/validator'
import fileIcon from '@/assets/img/file_icon.png'
import { IMAGE_FILE } from '@/constant/dict'

export default {

  props: {
    options: {
      type: Object,
      default: () => ({}),
    },

    uploadMethod: { type: Function },

    fileInfo: {
      type: Object,
      default: () => ({}),
    },

    onChange: { type: Function },
  },

  data () {
    return {
      IMAGE_FILE,
      uploadImg,
      fileIcon,
      innerFileList: [{}],
    }
  },

  computed: {
    configData () {
      return this.options?.bmbMbDetailItem || {}
    },
  },

  watch: {
    fileInfo: {
      handler (val) {
        this.innerFileList = [{ url: val.url }]
      },
      deep: true,
      immediate: true,
    },

    innerFileList: {
      handler (val) {
        if (this.onChange) {
          this.onChange({
            ...this.fileInfo,
            ...val[0],
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    isImage,

    handlerUploadSuccess (fileList) {
      this.$set(this.fileInfo, 'url', fileList[0].url)
    },

    deleteFile () {
      this.$set(this.fileInfo, 'uploadModelList', [])
    },

    async getUploadStatus (status) {
      // this.$set(fileInfo, 'fineshed', status === 'done')
    },
  },
}
